<div class="mt-5 text-center">
  <img ngSrc="assets/images/error-500.svg" alt="Error" height="120" width="auto">
  <h3 class="mt-3 mb-2">Error de servidor</h3>
  <p class="text-muted mb-3">Vaya, parece que algo salió mal. Por favor, inténtelo de nuevo más tarde...</p>
</div>
